export enum LLMConfigEndpoint {
  ROOT = '/llm/template-config',
}

export const getLLMConfigEndpoints = ({ channelId }: { channelId: string | number }) => ({
  GET_LLM_CONFIG: `${LLMConfigEndpoint.ROOT}/${channelId}`,
  UPDATE_LLM_CONFIG: `${LLMConfigEndpoint.ROOT}/${channelId}`,
});

export interface ILLMConfig {
  id: string;
  channelId: number;
  importantProductAttributeCodes?: string[];
  keyValuePropositions: string[];
}

// ============== DTO ==============

export interface IGetLLMConfigDTO {
  channelId: number;
}

export interface IUpdateLLMConfigDTO {
  channelId: number;
  importantProductAttributeCodes?: string[];
  keyValuePropositions: string[];
}

// ============== Response ==============

export type IGetLLMConfigResponse = ILLMConfig | null;

export interface IUpdateLLMConfigResponse extends ILLMConfig {}
